export default function Marquee({ items, className = "" }) {
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight text-white/20 px-6">
            {item}
          </span>
          <span className="h-2 w-2 rounded-full bg-bright/70" />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`relative overflow-hidden py-6 border-y border-white/5 ${className}`}>
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
